import BlockAddStudentsToClass from "./BlockAddStudentsToClass";
import BlockClassInvite from "./BlockClassInvite";
import BlockStudentLiveClass from "./BlockStudentLiveClass";
import BlockTeacherLiveClass from "./BlockTeacherLiveClass";
import ErrorBoundary from "./ErrorBoundary";
import BlockCustomDialog from "./BlockCustomDialog";
import BlockPlaylists from "./BlockPlaylists";
import BlockPlaylistDetail from "./BlockPlaylistDetail";
import BlockTopicDetail from "./BlockTopicDetail";
import BlockRecentlyPlayed from "./BlockRecentlyPlayed";
import BlockTeacherCreatePlan from "./BlockTeacherCreatePlan";
import BlockAddPlayListContent from "./BlockAddPlayListContent";
import BlockRemovePlayListContentData from "./BlockRemovePlayListContentData";
import BlockUploadAssignment from "./BlockUploadAssignment";
import BlockAssignmentList from "./BlockAssignmentList";
import BlockAddQuestionLandingScreen from "./BlockAddQuestionLandingScreeen";
import BlockQuestionList from "./BlockQuestionList";
import BlockAddQuestion from "./BlockAddQuestion";
import BlockAddQuestionContent from "./BlockAddQuestionContent";
import BlockRescheduleClass from "./BlockRescheduleClass";
import BlockDeleteClass from "./BlockDeleteClass";
import BlockCancelClass from "./BlockCancelClass";
import BlockDashboardInfo from "./BlockDashboardBockInfo";

const Blocks = {
  BlockAddStudentsToClass,
  BlockClassInvite,
  BlockStudentLiveClass,
  BlockTeacherLiveClass,
  ErrorBoundary,
  BlockCustomDialog,
  BlockPlaylists,
  BlockPlaylistDetail,
  BlockTopicDetail,
  BlockRecentlyPlayed,
  BlockTeacherCreatePlan,
  BlockAddPlayListContent,
  BlockAddPlayListContentData: BlockRemovePlayListContentData,
  BlockUploadAssignment,
  BlockAssignmentList,
  BlockAddQuestionLandingScreen,
  BlockQuestionList,
  BlockAddQuestion,
  BlockAddBooleanQuestion: BlockAddQuestionContent,
  BlockRescheduleClass,
  BlockDeleteClass,
  BlockCancelClass,
  BlockDashboardInfo,
};

export default Blocks;
